import { PopperPlacementType, Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<{ placement: PopperPlacementType }>()(
  (theme: Theme, { placement }) => ({
    text: {
      '&.MuiPaper-root': {
        border: '1px solid #a2a4d7',
        borderRadius: theme.spacing(2),
        backgroundColor: '#16171a',
        position: 'relative',
        top: placement === 'top' ? theme.spacing(-1) : 0,
        right: placement === 'right' ? theme.spacing(-1) : 0,
        backgroundImage: 'none',
      },
    },
  })
);
